import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
// 引入echarts
// import echarts from 'echarts'
const echarts = require("echarts");
//引入百度
// import BaiduMap from 'vue-baidu-map'
//引入dm5
import md5 from "js-md5";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "element-ui/lib/theme-chalk/display.css";
import { VueJsonp } from "vue-jsonp";
Vue.use(VueJsonp);
Vue.use(ElementUI);
import "./plugins/element.js";
// 导入字体图标
import "./assets/fonts/iconfont.css";
import "./assets/css/font-awesome.min.css";
// 导入全局样式表
import "./assets/css/global.css";

import "./assets/map/china";
import http from "./api/axios";

import "../src/build/version";

// 在main.js或需要使用的地方引入并建立连接
// import { createSocket } from './utils/websocket'
// createSocket('ws://ht2.illcc.com:9501')

// // 发送消息
// import { sendWSPush } from './utils/websocket'
// sendWSPush('你好,我是夏钊')

// // 接收消息
// const getsocketData = e => { // 创建接收消息函数
//     const data = e && e.detail.data
//     console.log(data)
// }

// import qs from 'qs'

// //配全局属性配置，在任意组件内可以使用this.$qs获取qs对象

// Vue.prototype.$qs = qs

// // 注册监听事件
// window.addEventListener('onmessageWS', getsocketData)

// // 在需要的时候卸载监听事件，比如离开页面
// window.removeEventListener('onmessageWS', getsocketData)

// 背景墙
import VueParticles from "vue-particles";
Vue.use(VueParticles);

Vue.prototype.md5 = md5;
Vue.prototype.$http = http;
Vue.prototype.$echarts = echarts;
Vue.config.productionTip = false;

Vue.prototype.hostName = localStorage.getItem("service_cname") + "/agent";

// Vue.use(BaiduMap, {
//     // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key /
//     ak: 'jcI3Q88g6V99OPBjLryoOqPTtsRdedHA'
// })

// 时间格式化筛子
Vue.filter("dateFormat", function(originVal) {
  const dt = new Date(originVal * 1000);

  const y = dt.getFullYear();
  const m = (dt.getMonth() + 1 + "").padStart(2, "0");
  const d = (dt.getDate() + "").padStart(2, "0");

  const hh = (dt.getHours() + "").padStart(2, "0");
  const mm = (dt.getMinutes() + "").padStart(2, "0");
  const ss = (dt.getSeconds() + "").padStart(2, "0");

  return y + "-" + m + "-" + d + " " + hh + ":" + mm + ":" + ss;
});

// 电话号码隐藏中间四位
Vue.filter("phone", function(value) {
  if (!value) return "";
  let str = value;
  str = str.toString().replace(/^(\d{3})(\d{4})(\d{4})/g, "$1****$3");
  return str;
});

Vue.filter("filters", function(value) {
  if (!value) return "";
  if (value.length > 6) {
    return value.slice(0, 6) + "...";
  }
  return value;
});

import dictionary from "@/services/dictionary";
dictionary.init();

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
